/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSalesTrendPointFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type SalesTrendPoint } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/sales/trend
 */
export interface TrendRequestBuilder extends BaseRequestBuilder<TrendRequestBuilder> {
    /**
     * Revenue and order count for each day, week or month of the window, counted in the requested time zone. Every bucket the window touches is returned, oldest first, with zeros where nothing was ordered, so two windows of the same length — this period and the one it is compared with — line up point for point. Weeks start on Monday; the first and last bucket can be partial. Order status is not considered; inactive orders are left out, as in every analytics figure.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SalesTrendPoint[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : Promise<SalesTrendPoint[] | undefined>;
    /**
     * Revenue and order count for each day, week or month of the window, counted in the requested time zone. Every bucket the window touches is returned, oldest first, with zeros where nothing was ordered, so two windows of the same length — this period and the one it is compared with — line up point for point. Weeks start on Monday; the first and last bucket can be partial. Order status is not considered; inactive orders are left out, as in every analytics figure.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TrendRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Revenue and order count for each day, week or month of the window, counted in the requested time zone. Every bucket the window touches is returned, oldest first, with zeros where nothing was ordered, so two windows of the same length — this period and the one it is compared with — line up point for point. Weeks start on Monday; the first and last bucket can be partial. Order status is not considered; inactive orders are left out, as in every analytics figure.
 */
export interface TrendRequestBuilderGetQueryParameters {
    /**
     * The width of each point: Day, Week (weeks start on Monday) or Month. Defaults to Month.
     */
    bucket?: string;
    /**
     * End of the window, inclusive. At most two years after the start.
     */
    endDate?: Date;
    /**
     * Start of the window, inclusive.
     */
    startDate?: Date;
    /**
     * IANA time zone the days are counted in, e.g. America/New_York. Defaults to UTC; an unknown zone falls back to UTC.
     */
    timeZone?: string;
}
/**
 * Uri template for the request builder.
 */
export const TrendRequestBuilderUriTemplate = "{+baseurl}/api/analytics/sales/trend?bucket={bucket}&endDate={endDate}&startDate={startDate}{&timeZone*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TrendRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TrendRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSalesTrendPointFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
